var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`button ${_vm.small? 'small': ''}`,on:{"click":_vm.close}},[_c('div',{staticClass:"general backslash"}),_c('div',{staticClass:"general slash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }